import { Step as MuiStep, colorsPalette, styled } from '@lingoda/ui';

export const Step = styled(MuiStep)(({ theme }) => ({
    height: 2,
    padding: 0,
    borderRightWidth: 4,
    borderRightStyle: 'solid',
    borderRightColor: theme.colors.border.inverse,
    background: colorsPalette.blackSolid[8],
    '&.Mui-completed': {
        background: 'transparent',
    },
}));
